import { defineMessages } from 'react-intl';

const translations = {
  page: {
    title: {
      id: 'pages.rbac.title',
      defaultMessage: 'Rbac',
      description: 'title of the rbac page',
    },
    rbac: {
      create: {
        button: {
          id: 'actions.add',
          defaultMessage: 'Create',
          description: 'title of the create role button',
        },
        title: {
          id: 'pages.rbac.create.title',
          defaultMessage: 'Create role',
          description: 'title of the create role drawer',
        },
      },
      edit: {
        title: {
          id: 'pages.rbac.edit.title',
          defaultMessage: 'Edit role',
          description: 'title of the edit role drawer',
        },
      },
      delete: {
        title: {
          id: 'pages.rbac.delete.title',
          defaultMessage: 'Delete role',
          description: 'title of the create role drawer',
        },
        text: {
          id: 'pages.rbac.delete.text',
          defaultMessage: "Are you sure you wan't to delete this role?",
          description: 'the text of the delete role confirm dialog',
        },
        actions: {
          delete: {
            id: 'actions.delete',
            defaultMessage: 'Delete',
            description: 'title of the delete role button',
          },
          cancel: {
            id: 'actions.cancel',
            defaultMessage: 'Cancel',
            description: 'title of the cancel role delete button',
          },
        },
      },
    },
  },
  feedback: {
    roleCreated: {
      id: 'pages.rbac.feedback.roleCreated',
      defaultMessage: 'Role has been created',
      description: 'title of the create role drawer',
    },
    roleNotCreated: {
      id: 'pages.rbac.feedback.roleNotCreated',
      defaultMessage: 'Could not create role',
      description: 'title of the create role drawer',
    },
    roleSaved: {
      id: 'pages.rbac.feedback.roleSaved',
      defaultMessage: 'Role has been saved',
      description: 'title of the save role drawer',
    },
    roleNotSaved: {
      id: 'pages.rbac.feedback.roleNotSaved',
      defaultMessage: 'Could not save role',
      description: 'title of the save role drawer',
    },
    roleDeleted: {
      id: 'pages.rbac.feedback.roleDeleted',
      defaultMessage: 'Role has been deleted',
      description: 'title of the save role drawer',
    },
    roleNotDeleted: {
      id: 'pages.rbac.feedback.roleNotDeleted',
      defaultMessage: 'Could not delete role',
      description: 'title of the save role drawer',
    },
  },
};

export default defineMessages(translations);
